import React from "react";
import {Carousel} from "antd";
import "./ObjectImageCarousel.scss"
import {IImage} from "../interfaces/IImage";

export function ObjectImageCarousel(p:{images?:string[]}) {

  return <Carousel arrows={true}>
    {p.images?.map((url,i) => <img alt="" key={i} src={url}/>)}
  </Carousel>
}